import { GlobalStyles } from '@mui/material';
import { alpha, Theme } from '@mui/material/styles';

/**
 * Styling for Dojo's 3D Secure challenge iframe.
 */

const panelMaxHeight = 650;

const threeDsStyles = (theme: Theme) => {
    const fade = `dojo-threeds-fade-in ${theme.transitions.duration.enteringScreen}ms ${theme.transitions.easing.easeOut}`;
    return {
        '@keyframes dojo-threeds-fade-in': {
            from: { opacity: 0 }
        },
        'body:has(iframe.threeDs)': {
            overflow: 'hidden'
        },
        'body:has(iframe.threeDs)::before': {
            content: '""',
            position: 'fixed',
            inset: 0,
            zIndex: theme.zIndex.modal + 1,
            backgroundColor: alpha(theme.palette.common.black, 0.5),
            animation: fade
        },
        'iframe.threeDs': {
            position: 'fixed',
            zIndex: theme.zIndex.modal + 2,
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: `calc(100% - ${theme.spacing(8)})`,
            maxWidth: theme.breakpoints.values.sm,
            height: `calc(100dvh - ${theme.spacing(8)})`,
            maxHeight: panelMaxHeight,
            display: 'block',
            border: 0,
            borderRadius: theme.shape.borderRadius,
            boxShadow: theme.shadows[24],
            backgroundColor: theme.palette.common.white,
            colorScheme: 'light',
            animation: fade
        },
        '@media (prefers-reduced-motion: reduce)': {
            'body:has(iframe.threeDs)::before, iframe.threeDs': {
                animation: 'none'
            }
        }
    };
};

export const ThreeDsGlobalStyles = () => <GlobalStyles styles={threeDsStyles} />;
